"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DoesNotContainElementValidator {
    constructor(nonSeed) {
        this.nonSeed = nonSeed;
    }
    isValid(input) {
        if (input) {
            for (let element of input) {
                if (element === this.nonSeed) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
}
exports.DoesNotContainElementValidator = DoesNotContainElementValidator;
//# sourceMappingURL=DoesNotContainElementValidator.js.map